const fr = {
  dashboard: {
    title: "TABLEAU DE BORD",
    greeting: "Bonjour",
    new_policy: "Nouvelle police",
    new_client: "Nouveau client",
    clients_actifs: "Clients actifs",
    dossiers_etude: "Dossiers en étude",
    prime_annuelle: "Prime annuelle",
    polices_actives: "polices actives",
    sinistres_ouverts: "sinistres ouverts",
    a_traiter: "Dossiers à traiter",
    rien_a_traiter: "Aucun dossier en attente — tout est à jour",
    portefeuille: "Portefeuille",
    polices: "polices",
    dash_st_validation: "Validation",
    dash_st_pieces: "Pièces",
    dash_st_demande: "Demande",
  },
  lang: { fr: 'Français', en: 'English', de: 'Deutsch', sv: 'Svenska' },

  nav: { rcpro_studies: "Demandes d'étude", gf_studies: "Demandes d'étude", gf_requests: "Demandes d'ouverture", gf_declarations: "Déclarations de volume d'affaire",
    voyageur_subtitle: 'Complétez votre dossier d\'indemnisation',
    creer_acces_subtitle: 'Créer un compte pour permettre au voyageur de compléter son dossier en ligne.',
    acces_deja: 'Un accès voyageur existe déjà pour ce dossier',
    role_voyageur: 'Voyageur',
    creer_acces_client: "Créer un accès client",
    creer_acces_client_subtitle: "Créez un compte pour permettre au client de gérer ses polices en ligne.",
    acces_client_cree: "Accès client créé — identifiants à transmettre",
    acces_client_deja: "Un accès client existe déjà pour ce compte",
    client_space: "Mon espace client",
    client_mes_polices: "Mes polices",
    role_client: "Client",
    dashboard: "Tableau de bord",
    section_pilotage: "Pilotage",
    role_manager: 'Manager',
    role_souscripteur: 'Admin',
    role_accounts: 'Accounts',
    role_it: 'IT',
    role_courtier: 'Courtier',
    role_client: 'Client',
    section_sinistres: 'Sinistre',
    section_gestion: 'Gestion',
    section_portfolio: 'Portefeuille',
    section_administration: 'Administration',
    utilisateurs: 'Comptes utilisateur',
    intermediaires: 'Intermédiaires',
    sinistres: 'Gestion Sinistre',
    clients: 'Clients',
    polices: 'RC Professionnelle',
    gf: 'Garantie Financière',
    crm_subtitle: 'CRM',
    prestataires: 'Prestataires & TOs',
    closed_dossiers: 'Dossiers clos',
    pending_payment: 'En attente paiement',
    pending_balances: 'Soldes en attente',
    pending_validation: 'En attente validation',
    gestion_doc: "Gestion documentaire",
  },

  common: { edit: "Modifier", modifier: "Modifier",
    saved: 'Enregistré',
    ok: 'OK',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    deleting: 'Suppression…',
    open: 'Ouvrir',
    modify: 'Modifier',
    consult: 'Consulter',
    generate: 'Générer',
    close: 'Fermer',
    previous: '← Précédent',
    next: 'Suivant →',
    yes: 'Oui',
    no: 'Non',
    loading: 'Chargement…',
    creating: 'Création…',
    slide: 'Slide',
    of: '/',
    all_countries: 'Tous les pays',
    all_statuses: 'Tous les statuts',
    actions: 'Actions',
    status: 'Statut',
    country: 'Pays',
    none: '—',
    not_found: 'Introuvable.',
    no_results: 'Aucun résultat trouvé.',
    error: 'Erreur',
    access_denied: 'Accès refusé',
    required: '*',
    optional: '(facultatif)',
    irreversible: 'Cette action est irréversible.',
    auto_generated: 'Auto-généré',
    locked: 'Verrouillé',
    consultation_only: '🔒 Consultation uniquement',
    generate_coming_soon: 'Template à venir',
    download: '⬇ Générer',
    locked_after_binding: '🔒 Disponible après souscription',
    locked_after_activation: '🔒 Après activation',
    yes_col: 'Oui',
    no_col: 'Non',
    suspend: 'Suspendre',
    reactivate: 'Réactiver',
    unlock_btn: 'Déverrouiller',
    unlock_confirm: 'Remettre ce document en attente de validation ?',
    doc_gf_cert_immat: "Certificat d'immatriculation",
    doc_gf_statuts: "Statuts de l'entreprise",
    doc_gf_cv_dirigeant: 'CV du dirigeant',
    doc_gf_piece_id: "Pièce d'identité du dirigeant",
    doc_gf_presentation_projet: 'Présentation du projet',
    doc_gf_previsionnel: "Prévisionnel d'activité détaillé",
    doc_gf_cgv: 'Conditions générales de vente',
    doc_gf_presentation_activites: 'Présentation des activités',
    doc_gf_previsionnel_annuel: "Prévisionnel d'activité pour l'année à garantir",
    doc_gf_bilan_cr: 'Dernier bilan et compte de résultat détaillé',
    doc_gf_attestation_rcpro: 'Attestation RC Professionnelle en cours',
    doc_gf_attestation_fonds: 'Attestation de pointe fonds détenus',
    readonly_banner: 'Vue en lecture seule — dépôt et visualisation uniquement',
    broker_readonly: 'En tant que courtier, vous pouvez uniquement consulter les fiches clients.',
    address_siege: 'Adresse du siège social',
    broker_status_locked: 'Prospect — statut défini par le souscripteur Arcus',
    accepted_label: 'accepté(s)',
    required_label: 'Requis',
    delete_btn: '🗑 Supprimer',
    doc_contrat_reservation: "Copie du contrat de réservation avec l'agence",
    doc_preuve_paiement: 'Preuve de paiement(s)',
    doc_bon_voucher: 'Bon / Voucher non utilisé (le cas échéant)',
    delete_confirm: 'Supprimer',
    coming_soon: "Fonctionnalité à venir",
  },

  status: { devis_rcpro: "Devis (en attente de pièces)", demande_pieces: "Demande de pièces et informations", en_cours_etude: "En cours d'étude", demande_ouverture: "Demande en attente", demande_refusee: "Demande refusée",
    actif: 'Actif',
    suspendu: 'Suspendu',
    prospect: 'Prospect',
    client_actif: 'Client actif',
    devis: 'Devis',
    souscrit: 'Souscrit',
    resilie: 'Résilié',
    sans_objet: 'Sans objet',
    amende: 'Amendé',
    projet_avenant: "Projet d'avenant",
    avenant_actif: 'Avenant actif',
    remplace: 'Remplacé',
    en_vigueur: 'En vigueur',
    renouvellement: 'Renouvellement',
    en_souscription: 'En souscription',
    renouvelee: "Renouvelée",
  },

  intermediaires: {
    title: 'Gestion des intermédiaires',
    create_btn: '+ Créer un intermédiaire',
    search_placeholder: 'Rechercher par nom, type, N° professionnel…',
    count: 'intermédiaire',
    count_plural: 'intermédiaires',
    not_assignable: '· Non affectable à un client',
    col_name: 'NOM / STRUCTURE',
    col_type: 'TYPE',
    col_country: 'PAYS',
    col_status: 'STATUT',
    col_actions: 'ACTIONS',
    type_courtier: 'Courtier',
    type_avocat: 'Avocat',
    type_association: 'Association',
    type_formation: 'Organisme de formation',
    contacts_count: 'contact',
    contacts_count_plural: 'contacts',
    unlock_btn: 'Déverrouiller',
    unlock_confirm: 'Remettre ce document en attente de validation ?',
    doc_gf_cert_immat: "Certificat d'immatriculation",
    doc_gf_statuts: "Statuts de l'entreprise",
    doc_gf_cv_dirigeant: 'CV du dirigeant',
    doc_gf_piece_id: "Pièce d'identité du dirigeant",
    doc_gf_presentation_projet: 'Présentation du projet',
    doc_gf_previsionnel: "Prévisionnel d'activité détaillé",
    doc_gf_cgv: 'Conditions générales de vente',
    doc_gf_presentation_activites: 'Présentation des activités',
    doc_gf_previsionnel_annuel: "Prévisionnel d'activité pour l'année à garantir",
    doc_gf_bilan_cr: 'Dernier bilan et compte de résultat détaillé',
    doc_gf_attestation_rcpro: 'Attestation RC Professionnelle en cours',
    doc_gf_attestation_fonds: 'Attestation de pointe fonds détenus',
    readonly_banner: 'Vue en lecture seule — dépôt et visualisation uniquement',
    broker_readonly: 'En tant que courtier, vous pouvez uniquement consulter les fiches clients.',
    address_siege: 'Adresse du siège social',
    broker_status_locked: 'Prospect — statut défini par le souscripteur Arcus',
    accepted_label: 'accepté(s)',
    required_label: 'Requis',
    delete_btn: '🗑 Supprimer',
    doc_contrat_reservation: "Copie du contrat de réservation avec l'agence",
    doc_preuve_paiement: 'Preuve de paiement(s)',
    doc_bon_voucher: 'Bon / Voucher non utilisé (le cas échéant)',
    delete_confirm: 'Êtes-vous certain de vouloir supprimer',
    new_title: 'Nouvel intermédiaire',
    edit_title: "Modifier l'intermédiaire",
    breadcrumb: 'Intermédiaires',
    tab_profile: "L'intermédiaire",
    tab_contacts: 'Les contacts',
    tab_contract: 'Conditions contractuelles',
    type_label: 'Type *',
    courtier_fields_title: 'CHAMPS SPÉCIFIQUES — COURTIER',
    professional_number: 'Numéro professionnel',
    reference_code: 'Code référence courtier',
    professional_number_placeholder: 'Ex. CIF-FR-123456',
    reference_code_placeholder: 'Ex. ARC-2024-001',
    structure_name: 'Nom de la structure *',
    legal_status: 'Statut juridique',
    registration_number: "Numéro d'immatriculation",
    registration_placeholder: 'Ex. 12345678900012',
    addresses: 'ADRESSES',
    main_address: '🏠 Adresse principale',
    add_address: '+ Ajouter une adresse',
    address_line1: 'Adresse 1',
    address_line2: 'Adresse 2',
    postal_code: 'Code postal',
    city: 'Ville',
    address1_placeholder: 'Numéro et nom de la rue',
    address2_placeholder: 'Complément (optionnel)',
    postal_placeholder: '75001',
    title_contact: 'Titre',
    role: 'Statut / Fonction',
    first_name: 'Prénom',
    last_name: 'Nom *',
    email: 'Email',
    phone: 'Téléphone',
    comm_recipient: 'Destinataire des communications',
    main_contact: 'Contact principal',
    add_contact: '+ Ajouter un contact',
    remunerated: 'Intermédiaire rémunéré ?',
    remunerated_desc: "Si oui, un taux de commission sera appliqué sur les contrats apportés.",
    commission_rate: 'Taux de commission *',
    commission_auto: 'La commission sera appliquée automatiquement sur les contrats associés.',
    not_remunerated_info: "Aucune commission ne sera générée pour cet intermédiaire.",
    suspension_date: 'Date de suspension',
  },

  clients: {
    title: 'Gestion des clients',
    create_btn: '+ Créer un client',
    search_placeholder: 'Rechercher par nom, activité, pays…',
    count: 'client',
    count_plural: 'clients',
    col_name: 'NOM / ENTREPRISE',
    col_activity: 'ACTIVITÉ PRINCIPALE',
    col_relation: 'RELATION',
    col_country: 'PAYS',
    col_status: 'STATUT',
    col_actions: 'ACTIONS',
    via: 'via',
    new_title: 'Nouveau client',
    edit_title: 'Modifier le client',
    breadcrumb: 'Clients',
    tab_relation: 'La relation',
    tab_company: "L'entreprise",
    tab_contacts: 'Les contacts',
    tab_activities: 'Les activités',
    client_status: 'Statut du client',
    client_status_desc: 'Détermine le niveau de suivi et les actions disponibles.',
    market: 'Marché *',
    market_placeholder: '— Sélectionner un pays —',
    relation_type: 'Type de relation *',
    direct: 'En direct',
    brokered: 'Intermédié',
    broker_label: 'Courtier *',
    broker_placeholder: '— Sélectionner un courtier —',
    broker_auto_commission: 'Le taux de commission du courtier sera appliqué automatiquement sur les polices.',
    third_party: 'TIERCE PARTIE',
    third_party_desc: "Sélectionner si un tiers est impliqué dans la relation (avocat, association, autre). Plusieurs choix possibles.",
    company_name: "Nom de l'entreprise *",
    company_placeholder: 'Ex. Voyages du Monde SARL',
    legal_status: 'Statut juridique',
    registration: "Numéro d'immatriculation (SIREN)",
    registration_placeholder: 'Ex. 892 345 678',
    unlock_btn: 'Déverrouiller',
    unlock_confirm: 'Remettre ce document en attente de validation ?',
    doc_gf_cert_immat: "Certificat d'immatriculation",
    doc_gf_statuts: "Statuts de l'entreprise",
    doc_gf_cv_dirigeant: 'CV du dirigeant',
    doc_gf_piece_id: "Pièce d'identité du dirigeant",
    doc_gf_presentation_projet: 'Présentation du projet',
    doc_gf_previsionnel: "Prévisionnel d'activité détaillé",
    doc_gf_cgv: 'Conditions générales de vente',
    doc_gf_presentation_activites: 'Présentation des activités',
    doc_gf_previsionnel_annuel: "Prévisionnel d'activité pour l'année à garantir",
    doc_gf_bilan_cr: 'Dernier bilan et compte de résultat détaillé',
    doc_gf_attestation_rcpro: 'Attestation RC Professionnelle en cours',
    doc_gf_attestation_fonds: 'Attestation de pointe fonds détenus',
    readonly_banner: 'Vue en lecture seule — dépôt et visualisation uniquement',
    broker_readonly: 'En tant que courtier, vous pouvez uniquement consulter les fiches clients.',
    address_siege: 'Adresse du siège social',
    broker_status_locked: 'Prospect — statut défini par le souscripteur Arcus',
    accepted_label: 'accepté(s)',
    required_label: 'Requis',
    delete_btn: '🗑 Supprimer',
    doc_contrat_reservation: "Copie du contrat de réservation avec l'agence",
    doc_preuve_paiement: 'Preuve de paiement(s)',
    doc_bon_voucher: 'Bon / Voucher non utilisé (le cas échéant)',
    delete_confirm: "Ce client a des polices actives. Supprimez-les d'abord.",
    contacts_section: 'Les contacts',
    main_contact: 'Contact principal',
    contact_number: 'Contact',
    add_contact: '+ Ajouter un contact',
    title_contact: 'Titre',
    role: 'Statut / Fonction',
    first_name: 'Prénom',
    last_name: 'Nom *',
    email: 'Email',
    phone: 'Téléphone',
    comm_recipient: 'Destinataire des communications',
    activities_section: 'Les activités',
    principal_activity: 'Activité principale',
    principal_activity_desc: "Activité dominante de l'agence (sélection unique)",
    secondary_activities: 'Activités secondaires',
    secondary_activities_desc: 'Autres activités exercées (sélection multiple)',
    no_activity_selected: "Sélectionnez d'abord une activité principale",
  },

  client_detail: {
    modify_fiche: 'Modifier la fiche',
    legal_status: 'Statut juridique',
    registration: 'N° immatriculation',
    market: 'Marché',
    distribution: 'Distribution',
    direct_distribution: 'En direct (+15 % Arcus)',
    brokered_distribution: 'Intermédié',
    address_label: '📍',
    policies_title: "Polices d'assurance",
    contract_count: 'contrat',
    contract_count_plural: 'contrats',
    create_policy: '+ Nouvelle police RC Pro',
    no_policies: 'Aucune police pour ce client. Cliquez sur "Nouvelle police RC Pro" pour créer un devis.',
    col_piece: 'N° PIÈCE',
    col_status: 'STATUT',
    col_premium: 'PRIME TTC',
    col_effect: "DATE D'EFFET",
    col_expiry: 'ÉCHÉANCE',
    col_actions: 'ACTIONS',
    renew: '🔄 Renouveler',
    terminate: 'Résilier',
    amendment_prefix: 'Avenant n°',
    new_amendment: '✎ Nouvel avenant',
    expiry_warning: '⚠',
    renewal_line: "Renouvelée le",
    collapse: "Réduire",
    expand: "Déplier",
    previous_period: "Période précédente",
  },

  polices: {
    title: 'RC Professionnelle',
    breadcrumb: 'Polices',
    portfolio_title: 'Portefeuille RC Pro',
    create_from_client: 'Les polices se créent depuis la fiche client',
    col_client: 'CLIENT / N° POLICE',
    col_country: 'PAYS',
    col_premium: 'PRIME TTC',
    col_expiry: 'ÉCHÉANCE',
    col_status: 'STATUT',
    tab_policy: 'La police',
    tab_tarification_gf: 'Tarification',
    tarif_add_period: '+ Ajouter une période',
    tarif_period: 'Période',
    tarif_date_debut: 'Date début',
    tarif_date_fin: 'Date fin',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Taux (%)',
    tarif_prime_ht: 'Prime HT',
    tarif_taxe: 'Taxe (9%)',
    tarif_prime_ttc: 'Prime TTC',
    tarif_total: 'TOTAL PRIME TTC',
    tarif_hint: 'Prime HT = Exposition × Taux · Taxe = 9% · Prime TTC = Prime HT + Taxe',
    tab_underwriting: 'Collecte des informations',
    tab_tarification: 'Espace tarification',
    tab_documents: 'Documents',
    client_readonly: 'Client — non modifiable',
    risk_insured_title: 'Le risque est-il déjà assuré ?',
    risk_insured_yes: 'Reprise à la concurrence — sinistralité obligatoire',
    risk_insured_no: 'Primo-souscription',
    current_insurer: 'Assureur actuel *',
    policy_status: 'Statut de la police',
    quote_number: 'Numéro de devis',
    policy_number: 'Numéro de police',
    policy_number_required: 'Obligatoire pour accéder à la tarification',
    effect_date: "Date d'effet *",
    expiry_date: "Date d'échéance",
    expiry_auto: '(auto +1 an)',
    renewal_note: '🔄 Renouvellement par tacite reconduction annuelle.',
    locked_banner: 'Contrat souscrit (consultation uniquement)',
    renewal_banner: '🔄 Renouvellement — période',
    to: 'au',
    create_amendment: '✎ Créer un amendement',
    renew_btn: '🔄 Renouveler',
    terminate_btn: 'Résilier',
    move_to_bound: 'Passer en Souscrit',
    confirm_binding_title: '⚠ Confirmer la souscription',
    confirm_binding_desc: 'Vous êtes sur le point de souscrire ce contrat.',
    confirm_binding_warning: 'Tous les champs seront verrouillés.',
    renewal_title: '🔄 Créer un renouvellement',
    renewal_question: 'Souhaitez-vous renouveler ce contrat sur les mêmes bases que le',
    renewal_last_active: 'dernier état actif',
    renewal_same: '✓ Oui — mêmes bases',
    renewal_same_desc: 'Le renouvellement reprend toutes les valeurs actuelles. Nouvelles dates automatiques.',
    renewal_new: '✎ Non — nouvelles bases',
    renewal_new_desc: "Le formulaire s'ouvre pré-rempli. Vous saisissez le nouveau CA.",
    declared_ca: 'CA déclaré (€) *',
    payment_freq: 'Fractionnement',
    loading_factors: "Questions sur les activités",
    discount_factors: 'Facteurs de minoration',
    covered_activities: "Activités exercées",
    special_conditions: 'Mentions spéciales',
    special_conditions_hint: 'Si vide → Néant dans le document.',
    special_conditions_placeholder: 'Clause particulière à faire apparaître dans le contrat…',
    loss_history: 'Sinistralité',
    loss_takeover: 'Reprise · Assureur',
    loss_closed: 'Sinistres clos (> 1 500 €)',
    loss_open: 'Sinistres ouverts (> 1 500 €)',
    loss_total_paid: 'Total payé (€)',
    loss_count: 'Nombre',
    loss_provision: 'Provisionné (€)',
    loss_partial: 'Part. payé (€)',
    loss_years: 'Années sur le relevé',
    net_premium: 'Prime HT',
    commission: 'Commission',
    tax: 'Taxe',
    gross_premium: 'Prime TTC',
    above_ceiling: "⚠ CA supérieur à 10 M€ — soumettre directement à l'assureur.",
    enter_ca: 'Saisir un CA pour afficher le calcul de prime.',
    floor_applied: '· Plancher 600 € appliqué',
    global_coeff: 'Coeff. global',
    freq_annual: 'Annuel (+0 %)',
    freq_semi: 'Semestriel (+2 %)',
    freq_quarter: 'Trimestriel (+4 %)',
    freq_month: 'Mensuel (+6 %)',
    internal_notes: 'Notes internes',
    notes_placeholder: "Notes de souscription, conditions particulières…",
    maj_q1: 'Plus de 50 % du CA lié à des voyages sportifs, mariages, EVG / EVJF ?',
    maj_q2: '50 % ou plus des passagers / CA vers pays hors UE, Scandinavie, Suisse, AUS, NZ ?',
    maj_q3: 'Extension de garantie USA / Canada ?',
    maj_q4: 'Voyages en groupe de plus de 10 personnes ?',
    maj_q5: '50 % ou plus des séjours incluent un transfert non standard (4×4, bateau, avion) ?',
    maj_q6: '50 % ou plus des séjours incluent des activités à risque (ski, plongée, parachutisme…) ?',
    min_q1: 'Historique sinistre vierge sur les 48 derniers mois ?',
    min_q2: "Dirigeant avec plus de 10 ans d'expérience en agence de voyages ou tour-opérateur ?",
    act1: 'Billetterie',
    act2: "Organisation de séjours ou de voyages en France ou à l'étranger",
    act3: 'Vente de séjours ou voyages organisés par un Tour Opérateur',
    act4: "Tourisme d'accueil",
    act5: "Vente à la commission (hôtel, location de voiture, assistance, théâtre…)",
    doc_language: '🌐 Langue : Français · Droit français applicable',
    doc_devis_warning: '⚠ Statut Devis — Police et attestation disponibles après souscription.',
    doc_locked_docs: 'Pièces contractuelles',
    doc_project: "Projet d'assurance",
    doc_project_desc: 'Document de présentation du devis',
    doc_policy: 'Conditions particulières',
    doc_cg: 'Conditions générales',
    doc_attestation: "Attestation d'assurance",
    doc_attestation_desc: 'Justificatif de couverture RC Pro',
    direct_plus15: 'En direct · +15 % Arcus',
    brokered_comm: 'Intermédié · % courtier',
    broker_view_banner: 'Vue courtier — consultation et dépôt de documents uniquement',
    broker_docs_locked: '🔒 Disponible après souscription',
    confirm_binding_docs_missing: 'Documents requis non validés — souscription impossible',
    doc_waiting_approval: 'Déposé mais en attente de validation',
    doc_not_uploaded: 'Non déposé',
    docs_in_french: 'Pièces en français',
    warn_date_effet_locked: "Modification possible mais sensible — vérifiez l'impact sur les avenants et le renouvellement éventuel",
    // ── Workflow étude/souscription RC Pro ──
    etude_title: "Étude du dossier",
    etude_locked_note: "Section verrouillée — la police est souscrite.",
    numero_projet: "Numéro de projet",
    date_effet_prev: "Date d'effet prévisionnelle",
    rcpro_step_devis: "Devis (en attente de pièces)",
    rcpro_step_devis_hint: "Le courtier/client complète le dossier et le transmet à Arcus.",
    rcpro_step_etude_hint: "Atteint quand le courtier/client transmet la demande de souscription.",
    repasser_devis_btn: "Repasser en Devis",
    repasser_devis_confirm_title: "Repasser le dossier en Devis ?",
    repasser_devis_confirm_desc: "Le formulaire redevient modifiable par le courtier/client ; les informations déjà saisies sont conservées. Le dossier repart au statut « Devis (en attente de pièces) ».",
    repasser_devis_confirm_btn: "Repasser en Devis",
    police_locked_note: "Section activée à la souscription de la police.",
    souscrire_btn: "Souscrire la police",
    souscrire_need_date: "Renseignez la date d'effet.",
    souscrire_need_npolice: "Renseignez le numéro de police.",
    souscrire_confirm_title: "Souscrire la police",
    souscrire_confirm_desc: "Confirmez les informations ci-dessous pour créer la police. La section « La Police » sera activée et l'étude verrouillée.",
    souscrire_date_label: "Date d'effet de la police",
    souscrire_npolice_label: "Numéro de police",
    souscrire_confirm_btn: "Souscrire",
    // ── RC Pro : onglet Souscription + mention spéciale ──
    ajustement_title: "Ajustement tarifaire",
    ajustement_hint: "Majoration volontaire de la prime (ne peut pas la diminuer).",
    ajustement_coeff: "Coefficient (ex. 1,25 = +25 %)",
    ajustement_min_note: "Minimum 1,00 (aucune diminution)",
    discount_hint: "Cochez pour appliquer la minoration au devis en cours.",
    dossier_decline_banner: "Dossier décliné — le risque a été refusé par Arcus.",
    dossier_decline_status: "Dossier décliné",
    exclusion_title: "Exclusion « festif »",
    exclusion_remove_label: "Retirer l'exclusion",
    exclusion_text: "Organisation, vente ou revente de voyages / séjours à caractère festif de type enterrement de vie de garçon / jeune fille, springbreak, séjours Bureau Des Étudiants…",
    exclusion_present_note: "L'exclusion figure dans le projet d'assurance.",
    exclusion_removed_note: "L'exclusion est retirée et n'apparaîtra pas dans le projet d'assurance.",
    mention_approve: "Approuver",
    mention_approved: "Mention approuvée par Arcus.",
    mention_client_request: "Requête du client / courtier",
    mention_none: "Aucune requête de mention spéciale.",
    mention_pending: "Requête transmise à Arcus Solutions — en attente de traitement.",
    mention_reformulate: "Reformuler",
    mention_reformulate_confirm: "Valider la reformulation",
    mention_reformulate_empty: "Saisissez la reformulation.",
    mention_reformulate_label: "Reformulation de la mention",
    mention_reformulated: "Mention reformulée par Arcus.",
    mention_refuse: "Refuser le risque",
    mention_refused: "Risque refusé — dossier décliné.",
    mention_submit_btn: "Soumettre la requête à Arcus Solutions",
    mention_submit_confirm_title: "Soumettre la requête à Arcus ?",
    mention_submit_confirm_desc: "Votre requête sera transmise à Arcus Solutions pour étude. La fiche sera verrouillée et aucun document ne pourra être téléchargé jusqu'à la décision d'Arcus.",
    mention_submit_confirm_btn: "Soumettre la requête",
    tab_souscription: "Souscription",
  },

  resiliation: {
    title: 'Résilier le contrat',
    title_amendment: "Résilier l'avenant",
    motif_label: 'Motif de résiliation *',
    motif_echeance: "Résiliation à l'échéance",
    motif_echeance_desc: "Le contrat est résilié à la date d'échéance.",
    motif_disparition: 'Disparition du risque',
    motif_disparition_desc: 'Date de résiliation à renseigner. Prorata calculé automatiquement.',
    motif_aggravation: 'Aggravation du risque',
    motif_aggravation_desc: 'Date de notification obligatoire. Résiliation 10 jours après. Prorata calculé.',
    motif_nonpaiement: 'Non-paiement',
    motif_nonpaiement_desc: 'Date de résiliation à renseigner. Pas de remboursement de prime.',
    notif_date: 'Date de notification *',
    resil_date: 'Date de résiliation *',
    j_plus_10: '(J+10)',
    prorata_title: 'Prorata temporis',
    prorata_total: 'Durée totale',
    prorata_remaining: 'Jours restants',
    prorata_refund: 'À rembourser',
    prorata_days: 'jours',
    note_label: 'Note interne',
    note_placeholder: 'Contexte de la résiliation…',
    confirm_btn: '✓ Confirmer la résiliation',
  },

  amendements: {
    tab_amendment: "L'avenant",
    tab_tarification_gf: 'Tarification',
    tarif_add_period: '+ Ajouter une période',
    tarif_period: 'Période',
    tarif_date_debut: 'Date début',
    tarif_date_fin: 'Date fin',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Taux (%)',
    tarif_prime_ht: 'Prime HT',
    tarif_taxe: 'Taxe (9%)',
    tarif_prime_ttc: 'Prime TTC',
    tarif_total: 'TOTAL PRIME TTC',
    tarif_hint: 'Prime HT = Exposition × Taux · Taxe = 9% · Prime TTC = Prime HT + Taxe',
    tab_underwriting: 'Collecte des informations',
    tab_documents: 'Documents',
    replaced_contract: 'Contrat remplacé',
    current_policy: 'N° police',
    current_premium: 'Prime TTC actuelle',
    client: 'Client',
    effect_date: "Date d'effet de l'avenant *",
    effect_date_hint: 'Saisie libre — peut être rétroactive ou future.',
    notes_label: "Notes internes (raison de l'avenant)",
    notes_placeholder: "Ex. : Changement d'activité, augmentation du CA…",
    comparison_title: '⇄ Comparaison avec le contrat en cours',
    current_contract: 'Contrat actuel',
    amendment_label: 'Avenant',
    difference: 'Différence',
    increase_msg: '↑ Augmentation · Appel de prime complémentaire',
    decrease_msg: '↓ Diminution · Régularisation à 0 € — pas de remboursement',
    stable_msg: '= Prime identique — avenant sans impact financier',
    activate_btn: 'Rendre actif',
    activate_disabled: "Date d'effet obligatoire pour activer",
    confirm_activate_title: "⚠ Confirmer l'activation",
    confirm_activate_desc: 'va remplacer le contrat actuel.',
    confirm_activate_irreversible: 'Le contrat original sera archivé.',
    locked_banner: '🔒 Avenant actif — champs verrouillés (consultation uniquement).',
    doc_project: "Projet d'avenant",
    doc_project_desc: 'Document de présentation',
    doc_project_warning: "⚠ Statut Projet d'avenant — Les pièces contractuelles se déverrouillent après activation.",
    doc_section_project: 'Dossier projet',
    doc_section_contracts: 'Pièces contractuelles',
    doc_appel_section: 'Appel de prime / Régularisation',
    doc_appel_title: 'Appel de prime complémentaire',
    doc_appel_amount: 'Montant',
    doc_regularisation: 'Courrier de régularisation',
    doc_regularisation_desc: "Régularisation à 0 € — pas d'appel de prime",
    delete_title: "Supprimer l'avenant",
    unlock_btn: 'Déverrouiller',
    unlock_confirm: 'Remettre ce document en attente de validation ?',
    doc_gf_cert_immat: "Certificat d'immatriculation",
    doc_gf_statuts: "Statuts de l'entreprise",
    doc_gf_cv_dirigeant: 'CV du dirigeant',
    doc_gf_piece_id: "Pièce d'identité du dirigeant",
    doc_gf_presentation_projet: 'Présentation du projet',
    doc_gf_previsionnel: "Prévisionnel d'activité détaillé",
    doc_gf_cgv: 'Conditions générales de vente',
    doc_gf_presentation_activites: 'Présentation des activités',
    doc_gf_previsionnel_annuel: "Prévisionnel d'activité pour l'année à garantir",
    doc_gf_bilan_cr: 'Dernier bilan et compte de résultat détaillé',
    doc_gf_attestation_rcpro: 'Attestation RC Professionnelle en cours',
    doc_gf_attestation_fonds: 'Attestation de pointe fonds détenus',
    readonly_banner: 'Vue en lecture seule — dépôt et visualisation uniquement',
    broker_readonly: 'En tant que courtier, vous pouvez uniquement consulter les fiches clients.',
    address_siege: 'Adresse du siège social',
    broker_status_locked: 'Prospect — statut défini par le souscripteur Arcus',
    accepted_label: 'accepté(s)',
    required_label: 'Requis',
    delete_btn: '🗑 Supprimer',
    doc_contrat_reservation: "Copie du contrat de réservation avec l'agence",
    doc_preuve_paiement: 'Preuve de paiement(s)',
    doc_bon_voucher: 'Bon / Voucher non utilisé (le cas échéant)',
    delete_confirm: "Êtes-vous certain de vouloir supprimer l'avenant",
    resiliation_info_title: 'Avenant résilié',
    resiliation_motif: 'Motif',
    resiliation_date: 'Date',
    resiliation_prorata: 'Prorata',
    new_amendment: '✎ Nouvel avenant',
  },

  documents: {
    cp: 'CP',
    attestation: 'Attestation',
    cg: 'CG',
    policy: 'Conditions particulières',
    general_conditions: 'Conditions générales',
    certificate: "Attestation d'assurance",
    quote: "Projet d'assurance",
  },

  auth: {
    forgot_password: "Mot de passe oublié ?",
    forgot_title: "Mot de passe oublié",
    forgot_desc: "Entrez votre email, nous vous enverrons un lien pour définir un nouveau mot de passe.",
    forgot_btn: "Envoyer le lien",
    forgot_sent: "Si un compte existe avec cette adresse, un lien de réinitialisation vient d'être envoyé.",
    back_to_login: "Retour à la connexion",
    reset_title: "Nouveau mot de passe",
    reset_desc: "Choisissez un mot de passe sécurisé (8 caractères minimum).",
    reset_btn: "Définir le mot de passe",
    reset_success: "Mot de passe défini. Vous pouvez maintenant vous connecter.",
    redirecting: "Redirection vers la page de connexion…",
    password_mismatch: "Les mots de passe ne correspondent pas.",
    password_too_short: "8 caractères minimum.",
    email_required: "Email obligatoire.",
    welcome: 'Bienvenue',
    sign_in_desc: 'Connectez-vous à votre espace ARCUSCONNECT',
    email: 'Adresse email',
    email_placeholder: 'votre@email.fr',
    password: 'Mot de passe',
    password_placeholder: '••••••••',
    sign_in: 'Se connecter',
    signing_in: 'Connexion en cours…',
    logout: 'Se déconnecter',
    fill_all: 'Veuillez remplir tous les champs',
    access_levels: "Niveaux d'accès",
    change_password: 'Changer le mot de passe',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer le mot de passe',
    password_changed: 'Mot de passe modifié avec succès',
  },
  sinistres: {
    title: 'Gestion Sinistre',
    subtitle: "Procédures d'indemnisation suite à défaillance financière d'agences de voyages",
    open_procedure: 'Ouvrir une procédure',
    filter_all: 'Toutes',
    col_numero: 'N° Procédure', col_agence: 'Agence de voyages', col_statut: 'Statut',
    col_date_ouv: "Date ouverture", col_date_fin: 'Fin indemnisations', col_actions: 'Actions',
    no_procedures: 'Aucune procédure de sinistre enregistrée.',
    open_btn: 'Ouvrir', loading: 'Chargement…',
    modal_title: 'Ouvrir une procédure',
    modal_subtitle: "Sélectionnez l'agence en défaillance et définissez les dates de la procédure.",
    select_agence: '— Sélectionner une agence —',
    date_ouverture: "Date d'ouverture *", date_fin: 'Date fin des indemnisations',
    notes: 'Notes internes (optionnel)', notes_placeholder: 'Contexte, informations utiles…',
    valider: 'Valider →', creation: 'Création…',
    confirm_title: 'Confirmation requise', confirm_subtitle: 'Action irréversible — Manager uniquement',
    confirm_about: "Vous êtes sur le point d'ouvrir officiellement la procédure pour :",
    confirm_warning: "⚠ Cette action verrouillera définitivement l'agence et ne pourra pas être annulée.",
    confirm_no_manager: "Seul un compte Manager peut confirmer cette ouverture.",
    annuler_procedure: '✕ Annuler la procédure',
    confirmer_ouverture: "✓ Confirmer l'ouverture", confirmation_loading: 'Confirmation…',
    agence_locked: 'Agence verrouillée', procedure_label: 'Procédure de sinistre',
    cloturer: 'Clôturer la procédure', infos_procedure: 'Informations de la procédure',
    modifier: '✎ Modifier', tracabilite: 'Traçabilité',
    cree: 'Procédure créée', confirmee: 'Procédure confirmée et ouverte',
    cloturee_label: 'Procédure clôturée', par: 'par',
    cloturer_confirm_title: 'Clôturer la procédure ?',
    cloturer_confirm_body: 'La procédure sera marquée comme clôturée. Cette action ne peut pas être annulée.',
    cloturer_btn: 'Clôturer', pending_alert: 'En attente de confirmation Manager',
    pending_desc: "Cette procédure a été créée mais n'est pas encore officiellement ouverte.",
    statut_ouverture_pendante: 'En attente de confirmation',
    statut_ouverte: 'Procédure ouverte', statut_cloturee: 'Clôturée',
    dossiers_title: "Dossiers d'indemnisation",
    ajouter_dossier: '+ Ajouter un dossier',
    no_dossiers: 'Aucun dossier enregistré. Cliquez sur "+ Ajouter un dossier" pour commencer.',
    pending_dossiers: "La procédure doit être confirmée par un Manager avant d'ajouter des dossiers.",
    col_souhait: 'Souhait',
    col_montant_total: 'Montant voyage',
    col_acompte: 'Acompte payé',
    col_solde: 'Solde restant',
    col_numero_dossier: 'N° Dossier', col_voyageur: 'Bénéficiaire', col_type: 'Type',
    nouveau_dossier: 'Nouveau dossier',
    nouveau_dossier_subtitle: 'Enregistrez un nouveau bénéficiaire de la garantie financière.',
    type_beneficiaire: 'Type de bénéficiaire',
    particulier: '👤 Particulier', professionnel: '🏢 Professionnel',
    nom_particulier: 'Nom / Prénom *', nom_professionnel: 'Raison sociale *',
    creer_dossier: 'Créer le dossier →', creation_dossier: 'Création…',
    statut_dossier: 'Statut du dossier', reserved_manager: 'Réservé au Manager',
    validation_required: 'Validation Manager requise',
    validation_desc: 'Ce dossier est prêt pour validation finale avant paiement.',
    decliner: '✕ Décliner', valider_paiement: '✓ Valider le paiement',
    pieces_title: 'Pièces justificatives',
    pieces_desc: 'Upload et validation des documents du bénéficiaire',
    finances_title: 'Données financières',
    finances_desc: 'Montant du voyage, acomptes versés, indemnisation due',
    banque_title: 'Informations bancaires',
    banque_desc: 'IBAN, titulaire, établissement bancaire',
    a_developper: 'À développer',
    voyageur_info: 'Informations du bénéficiaire',
    benef_intro: 'Merci de répondre aux questions suivantes.',
    submit_blocked_hint: 'Complétez les informations obligatoires et fournissez toutes les pièces pour pouvoir soumettre.',
    submit_missing_title: 'Pour soumettre votre dossier, il reste à compléter :',
    submit_missing_fields: 'Informations obligatoires manquantes :',
    submit_missing_pieces: 'Pièces justificatives à fournir :',
    piece_label_generic: 'Pièce justificative',
    passer_en_cours: 'Passer en cours de traitement',
    passer_en_cours_title: 'Passer le dossier en cours de traitement ?',
    passer_en_cours_desc: 'Le dossier passera au statut « En cours de traitement », ce qui vous permet de poursuivre son traitement sans attendre la transmission par le voyageur. Pensez à enregistrer vos modifications au préalable.',
    benef_date_depart: 'Date de départ du voyage',
    benef_carte_warning: 'Veuillez effectuer une demande de remboursement ou une réclamation au titre de l\'article 75. Si votre banque émettrice ou votre fournisseur de carte de crédit a refusé votre demande, veuillez fournir une preuve ou un accusé de réception de ce refus dans le cadre de votre dossier de réclamation.',
    benef_voyageurs_label: 'Voyageurs concernés',
    benef_add_voyageur: 'Ajouter un voyageur',
    benef_voyageurs_groupe: 'S\'il s\'agit d\'un groupe de plus de 10 personnes, merci de fournir la liste des voyageurs en accompagnement des pièces justificatives dans la section suivante.',
    voyageur_titre: 'Titre',
    voyageur_nom: 'Nom',
    voyageur_prenom: 'Prénom',
    voyageur_email: 'Adresse email',
    voyageur_telephone: 'Téléphone',
    voyageur_titre_m: 'Monsieur',
    voyageur_titre_mme: 'Madame',
    voyageur_titre_mmme: 'Monsieur / Madame',
    voyageur_titre_ste: 'Entreprise',
    voyageur_titre_asso: 'Association',
    voyage_info: 'Informations relatives au voyage',
    voyage_intro: 'Merci de vérifier les informations fournies par le déclarant et renseigner les champs restants, grâce aux documents de voyage. Si nécessaire, corriger la section Informations du voyage.',
    voyage_montant_total: 'Montant total du voyage (€)',
    voyage_acompte: 'Acompte payé (€)',
    voyage_solde: 'Solde restant (€)',
    voyage_solde_auto: 'Calculé automatiquement : Montant total − Acompte',
    voyage_appel_fonds: 'Générer un appel de fonds',
    voyage_appel_fonds_title: 'Appel de fonds',
    voyage_appel_fonds_soon: "Le template d'appel de fonds est en cours de préparation.",
    voyage_appel_fonds_preview: 'Aperçu — à titre indicatif',
    voyage_appel_fonds_email: 'Envoyer par email',
    voyage_appel_fonds_copy: 'Copier',
    voyage_appel_fonds_copied: 'Copié !',
    souhait_label: 'Souhait du voyageur',
    souhait_remboursement: 'Remboursement',
    souhait_maintien: 'Maintien du voyage',
    souhait_rapatriement: 'Rapatriement',
    paiement_title: 'Gestion des paiements',
    paiement_type: 'Type de destinataire',
    paiement_nom: 'Nom',
    paiement_prenom: 'Prénom',
    paiement_adresse: 'Adresse',
    paiement_cp: 'Code postal',
    paiement_ville: 'Ville',
    paiement_iban: 'IBAN',
    paiement_swift: 'Code SWIFT / BIC',
    paiement_reference: 'Référence de paiement',
    paiement_ref_auto: 'Générée automatiquement',
    paiement_montant: 'Montant à payer (€)',
    paiement_ajouter: '+ Ajouter un paiement',
    paiement_numero: 'Paiement n°',
    paiement_aucun: 'Aucun paiement enregistré.',
    paiement_particulier: 'Particulier',
    paiement_professionnel: 'Professionnel',
    supprimer_dossier: 'Supprimer le dossier',
    supprimer_dossier_confirm: 'Êtes-vous sûr de vouloir supprimer ce dossier ? Cette action est irréversible.',
    dossiers_count: '{n} dossier enregistré',
    dossiers_count_pl: '{n} dossiers enregistrés',
    type_particulier: '👤 Particulier',
    type_professionnel: '🏢 Professionnel',
    dos_statut_en_attente_informations: 'En attente des informations',
    dos_statut_en_cours_traitement: 'En cours de traitement',
    dos_statut_attente_validation: 'En attente de validation',
    dos_statut_attente_paiement_solde: 'Attente paiement du solde',
    dos_statut_solde_paye: 'Solde payé',
    dos_statut_attente_paiement_compta: 'En attente paiement comptabilité',
    dos_statut_paiement_realise: 'Paiement réalisé',
    dos_statut_decline: 'Dossier décliné',
statut_auto_info: 'Le statut évolue automatiquement selon les actions réalisées sur le dossier.',
    date_limite_paiement: 'Date limite de paiement',
    appel_fonds_pdf: 'Générer le PDF Appel de fonds',
    appel_fonds_email_pdf: 'Envoyer par email',
    appel_fonds_dl: 'Téléchargement en cours…',
    benef_montant_facture: 'Quel montant total vous a été facturé ? (€)',
    benef_type_reglement: 'Avez-vous payé un acompte ou la totalité ?',
    benef_type_acompte: 'Acompte',
    benef_type_totalite: 'Totalité',
    benef_montant_acompte: 'Pour quel montant ? (€)',
    benef_modes_paiement: 'Comment avez-vous payé ?',
    benef_mode_carte: 'Carte bancaire',
    benef_mode_virement: 'Virement bancaire',
    benef_mode_cheque: 'Chèque',
    benef_mode_especes: 'Espèces',
    benef_mode_cadeau: 'Chèque cadeau / Avoir / Liste de mariage',
    benef_nb_voyageurs: 'Combien de voyageurs sont concernés ?',
    benef_souhait_client: 'Que souhaitez-vous ?',
    benef_souhait_remboursement: 'Être remboursé',
    benef_souhait_maintien: 'Maintenir mon voyage',
    benef_souhait_rapatriement: 'Être rapatrié',
    docs_admin_title: 'Documents',
    docs_admin_generer_pdf: 'Générer le PDF Appel de fonds',
    docs_admin_pdf_saved: 'PDF généré et enregistré',
    docs_admin_ajouter: '+ Ajouter un document',
    docs_admin_nom_label: 'Nom du document',
    docs_admin_aucun: 'Aucun document enregistré.',
    docs_admin_appel_fonds: 'Appel de fonds',
    creer_acces_subtitle: "Créez un compte pour permettre au voyageur de compléter son dossier en ligne.",
    creer_acces_voyageur: "Créer un accès voyageur",
    creer_acces_subtitle: "Créez un compte pour permettre au voyageur de compléter son dossier en ligne.",
    acces_email: "Email du voyageur",
    acces_password: "Mot de passe temporaire",
    acces_generer: "Générer un accès",
    acces_cree: "Accès créé — identifiants à transmettre au voyageur",
    voyageur_space: "Mon espace sinistre",
    voyageur_mon_dossier: "Mon dossier",
    err_required: "Agence et date d'ouverture obligatoires",
    warning_manager: "La validation devra être confirmée par un Manager avant que la procédure ne soit officiellement ouverte. Cette confirmation verrouillera définitivement l'agence concernée.",
  },

  collecte: {
    title: 'Déclaration de Risque — Garantie Financière',
    dr_ref: 'Référence : DR-V-2401 · arcus-solutions.fr',
    section_renseignements: 'Les renseignements généraux',
    nom_social: 'Nom ou raison sociale *',
    nom_commercial: 'Nom commercial (si différent)',
    directeur: 'Directeur / Gérant',
    adresse: 'Adresse',
    forme_juridique: 'Forme juridique',
    capital_social: 'Capital social',
    siren: 'Numéro SIREN',
    site_internet: 'Site internet',
    date_creation: 'Date de création',
    date_cloture: 'Date de clôture annuelle',
    nb_agences: "Nombre d'agences",
    nb_collaborateurs: 'Nombre de collaborateurs',
    immat_atout_france: "N° immatriculation Atout France",
    rc_pro_numero: "Assurance RC Professionnelle n°",
    rc_pro_compagnie: "Nom de la compagnie d'assurance",
    rc_pro_echeance: 'Échéance RC Pro',
    banque_title: 'Banque principale',
    ec_title: 'Expert-comptable',
    correspondant: 'Correspondant',
    section_dirigeants: 'Les dirigeants',
    dir_nom: 'Nom *',
    dir_formations: 'Formations professionnelles',
    dir_annees: "Années d'expérience (tourisme)",
    dir_pct: '% du Capital Social',
    dir_situations: "Le dirigeant / actionnaire a-t-il été dans une de ces situations ?",
    dir_sauvegarde: 'Procédure de sauvegarde',
    dir_redressement: 'Redressement Judiciaire',
    dir_liquidation: 'Liquidation Judiciaire',
    dir_infos: 'Informations importantes dont vous souhaitez nous faire part',
    dir_add: '+ Ajouter un dirigeant / actionnaire',
    dir_del: 'Supprimer',
    dir_num: 'Dirigeant / Actionnaire',
    section_patrimoine: 'Le patrimoine des dirigeants',
    pat_nom: 'Nom du dirigeant',
    pat_estimation: 'Estimation (€)',
    pat_type_immo: 'Type patrimoine immobilier',
    pat_adresse_immo: 'Adresse du bien',
    pat_type_mobilier: 'Type patrimoine mobilier',
    pat_prets: 'Prêts en cours (€)',
    pat_etablissement: 'Établissement de souscription',
    pat_capital: 'Capital investi (€)',
    pat_add: '+ Ajouter un patrimoine dirigeant',
    section_societes: 'Informations sur les autres sociétés des actionnaires',
    soc_warning: "Merci de remplir ce tableau et de joindre la dernière liasse de chacune des structures. En cas d'historique de dépôt de bilan, le préciser.",
    soc_nom: 'Nom / Raison sociale',
    soc_associe: 'Associé en lien',
    soc_date: 'Date création',
    soc_ca: 'CA (N-1) €',
    soc_resultat: 'Résultat net (N-1) €',
    soc_add: '+ Ajouter une société',
    section_presentation: "Présentation succincte de votre activité / du projet",
    description_label: "Décrivez votre activité / votre projet *",
    description_placeholder: "Description de l'activité ou du projet de création…",
    reseau_label: "Avez-vous / allez-vous adhérer à un réseau ? Si oui, lequel ?",
    reseau_placeholder: "Ex. Selectour, Afat, Thomas Cook…",
    ca_title: "Répartition du Volume d'Affaires (€)",
    ca_forfaits_dist: "Forfaits — Distribution (€)",
    ca_forfaits_prod: "Forfaits — Production (€)",
    ca_prestations: "Prestations touristiques sèches (€)",
    ca_transport: "Transport secs (€)",
    ca_total: "TOTAL Volume d'Affaires (€)",
    clientele_btoc: "Clientèle BtoC (Particuliers / Entreprises / CE)",
    clientele_btob: "Clientèle BtoB (autres professionnels tourisme)",
    clientele_autres: "Autres clientèle",
    mode_distrib: "Mode de distribution (site, agence, réseau…)",
    fournisseurs_label: "Principaux fournisseurs (TO, réceptifs, hôtels, DMC…)",
    fournisseurs_placeholder: "Ex. Jet tours, Kuoni, Accor…",
    section_complement: "Informations complémentaires",
    engagement_label: "Engagement de volume avec vos fournisseurs ? Détailler si oui",
    delais_label: "Conditions / délais de règlement fournisseurs",
    repartition_monde: "Répartition de l'activité dans le monde (%)",
    reglement_title: "Mode de règlement des clients (%)",
    reglement_especes: "Espèces %",
    reglement_cheque: "Chèque %",
    reglement_virement: "Virement / Prélèvement %",
    reglement_carte: "Carte %",
    passerelle_label: "Faites-vous appel à une passerelle de paiement (merchant acquirer) ?",
    passerelle_nom: "Si oui, lequel",
    passerelle_delai: "Délai de transfert des fonds (jours)",
    section_previsionnel: "Le prévisionnel financier",
    pct_acompte: "% d'acompte prélevé à la réservation",
    mois_reservation: "En moyenne, combien de mois à l'avance les clients réservent-ils ?",
    mois_solde: "Combien de mois avant le départ le solde est-il réglé ?",
    montant_moyen: "Montant moyen dépensé par voyageur (€)",
    previsionnel_title: "Prévisionnel Volume d'Affaires par date de départ — période à garantir",
    previsionnel_desc: "Prendre en compte uniquement le Volume d'Affaires concernant les prestations réalisées. Exemple : Un groupe de 10 personnes part en juillet, le Volume d'Affaires est de 10 000 €, merci d'indiquer en juillet 10 000 €.",
    previsionnel_col1: "Mois / Année",
    previsionnel_col2: "Prestations initialement déclarées (€)",
    previsionnel_total: "TOTAL",
    previsionnel_hint: "Saisir le 1er mois — les 11 mois suivants se remplissent automatiquement",
  },

    rcpro_studies: {
    title: "Demandes de souscription RC Pro en cours d'étude",
  },
  gf_studies: {
    title: "Dossiers en cours d'étude",
    count: "dossier",
    count_plural: "dossiers",
    empty: "Aucun dossier en cours d'étude.",
    col_client: "Client",
    col_broker: "Courtier",
    col_submitter: "Soumis par",
    col_date: "Soumis le",
    col_actions: "Actions",
    study_btn: "Étudier le dossier",
  },
  gf_declarations: {
    title: "Déclarations de volume d'affaire",
    count: "dossier",
    count_plural: "dossiers",
    empty: "Aucune déclaration en attente.",
    col_client: "Client",
    col_broker: "Courtier",
    col_period: "Période déclarée",
    col_declared: "Déclaré le",
    col_amount: "Réalisé / Prévisionnel",
    col_actions: "Actions",
    review_btn: "Examiner",
    over_forecast: "CA en hausse",
    vs_prev: "prév.",
  },
  gf_requests: {
    title: "Demandes d'ouverture de garantie financière",
    count: "demande",
    count_plural: "demandes",
    empty: "Aucune demande d'ouverture en attente.",
    col_client: "Client",
    col_broker: "Courtier",
    col_requester: "Demandeur",
    col_date: "Demandé le",
    col_actions: "Actions",
    validate: "Valider",
    refuse: "Refuser",
    refuse_title: "Refuser la demande",
    refuse_desc: "Indiquez le motif du refus pour",
    refuse_motif_ph: "Motif du refus (facultatif)",
    refuse_confirm: "Confirmer le refus",
  },
  rcpro: {
    submit_btn: "Soumettre la demande de souscription",
    submit_blocked_hint: "Déposez tous les documents de souscription requis pour pouvoir soumettre.",
    submit_missing_title: "Pour soumettre votre demande de souscription, il reste :",
    submit_missing_docs: "Documents de souscription à déposer.",
    submitted_banner: "Demande de souscription soumise à Arcus Solutions — en cours d'étude. Le formulaire est verrouillé le temps de l'instruction.",
    submit_confirm_title: "Soumettre la demande de souscription ?",
    submit_confirm_desc: "Votre demande (documents de souscription) va être transmise à l'équipe Arcus Solutions pour instruction. Le formulaire sera verrouillé le temps de l'étude. Vous serez informé de la suite.",
    submit_confirm_btn: "Soumettre",
  },
  notes_int: {
    open: "Discussion interne",
    title: "Discussion interne",
    scope_client: "Fil rattaché à ce client",
    scope_police: "Fil rattaché à ce contrat",
    empty: "Aucun échange interne pour le moment. Ajoutez un commentaire pour démarrer l'historique de ce dossier.",
    placeholder: "Ajouter un commentaire interne…",
    attach: "Joindre des fichiers",
    drop_here: "Déposez les fichiers ici",
    hint: "Glissez-déposez un fichier ou un email · Ctrl+Entrée pour envoyer",
    readonly: "Consultation seule pour ce profil.",
    delete_confirm: "Supprimer ce commentaire ?",
  },
  gf: { submit_btn: "Soumettre le dossier à Arcus", submit_blocked_hint: "Complétez la collecte et déposez tous les documents requis pour pouvoir soumettre.", submit_missing_title: "Pour soumettre votre dossier à Arcus Solutions, il reste à compléter :", submit_missing_collecte: "Informations obligatoires manquantes (Collecte des informations) :", submit_missing_docs: "Documents de souscription à déposer.", submitted_banner: "Dossier soumis à Arcus Solutions — en cours d'étude. Le formulaire est verrouillé le temps de l'instruction.", submit_confirm_title: "Soumettre le dossier à Arcus Solutions ?", submit_confirm_desc: "Votre dossier (collecte + documents) va être transmis à l'équipe Arcus Solutions pour instruction. Le formulaire sera verrouillé le temps de l'étude. Vous serez informé de la suite.", submit_confirm_btn: "Soumettre", request_open_btn: "Demander une ouverture de dossier de garantie financière", request_done_msg: "Votre demande d'ouverture de dossier a été transmise à l'équipe Arcus Solutions, qui va revenir vers vous pour son instruction dans les meilleurs délais.", awaiting_validation: "En attente de validation",
    tab_surveillance: "Surveillance du risque",
    surveillance_intro_title: "Suivi du chiffre d'affaires réel",
    surveillance_intro_text: "À échéances régulières, le client déclare son CA réalisé pour vérifier la cohérence avec le prévisionnel. Cette donnée alimente le suivi du fonds de garantie.",
    surveillance_frequency_label: "Fréquence de surveillance",
    surveillance_freq_trim: "Trimestrielle",
    surveillance_freq_sem: "Semestrielle",
    surveillance_freq_not_set: "Non définie",
    surveillance_pick_freq: "Sélectionnez la fréquence de surveillance pour générer les périodes de déclaration.",
    surveillance_not_subscribed: "Les périodes de déclaration seront générées dès la souscription de la police.",
    surveillance_period: "Période",
    surveillance_declaration_in: "Déclaration attendue en",
    surveillance_col_month: "Mois",
    surveillance_col_previsionnel: "Prévisionnel",
    surveillance_col_realise: "Prestations réalisées",
    surveillance_col_ecart: "Écart",
    surveillance_total: "Total",
    surveillance_declared_at: "Déclarée le",
    surveillance_validated_at: "Validée le",
    surveillance_declare_btn: "Déclarer à Arcus Solutions",
    surveillance_validate_btn: "Valider la déclaration",
    surveillance_status_a_venir: "À venir",
    surveillance_status_a_declarer: "À déclarer",
    surveillance_status_declaree: "Déclarée",
    surveillance_status_validee: "Validée",
    surveillance_reset_title: "Changer la fréquence ?",
    surveillance_reset_warning: "Modifier la fréquence va supprimer les périodes existantes ainsi que toutes les déclarations déjà saisies. Cette action est irréversible.",
    surveillance_reset_confirm: "Confirmer et réinitialiser",
    create_variation: "Créer une variation",
    renew_procedure: "Créer une procédure de renouvellement",
    terminate_gf: "Résilier",
    title: 'Garantie Financière',
    nav: 'Garantie Financière',
    tab_policy: 'La police',
    tab_tarification_gf: 'Tarification',
    tarif_add_period: '+ Ajouter une période',
    tarif_period: 'Période',
    tarif_date_debut: 'Date début',
    tarif_date_fin: 'Date fin',
    tarif_exposition: 'Exposition (€)',
    tarif_taux: 'Taux (%)',
    tarif_prime_ht: 'Prime HT',
    tarif_taxe: 'Taxe (9%)',
    tarif_prime_ttc: 'Prime TTC',
    tarif_total: 'TOTAL PRIME TTC',
    tarif_hint: 'Prime HT = Exposition × Taux · Taxe = 9% · Prime TTC = Prime HT + Taxe',
    tab_underwriting: 'Collecte des informations',
    tab_documents: 'Documents',
    tab_souscription: 'Documents de souscription',
    create_policy: '+ Nouvelle police GF',
    portfolio_title: 'Portefeuille Garantie Financière',
    contexte_label: 'Contexte de la demande *',
    contexte_creation: "Création d'entreprise",
    contexte_historique: 'Société avec historique',
    contexte_ajout: "Ajout d'activité Tourisme",
    contexte_hint_creation: 'Société en cours de création — 7 documents requis',
    contexte_hint_existant: 'Société existante — 10 documents requis',
    collecte_title: 'Déclaration de Risque — Garantie Financière',
    tarification_placeholder_sub: 'Les paramètres seront configurés dans une prochaine version.',
    warn_date_effet_locked: "Modification possible mais sensible — pensez à réinitialiser les périodes de surveillance si besoin",
    // ── Payment Graph (onglet Arcus) ──
    tab_payment_graph: "Payment Graph",
    pg_title: "Bond Graph — Exposition théorique",
    pg_subtitle: "Calcul automatique du risque et de la prime à partir du prévisionnel financier.",
    pg_incomplete: "Complétez le « Prévisionnel financier » (tableau du volume d'affaires) dans l'onglet Collecte des informations pour générer le Bond Graph.",
    pg_params_title: "Paramètres issus de la collecte",
    pg_param_acompte: "Acompte",
    pg_param_solde: "Solde",
    pg_param_reserv: "Réservation à l'avance",
    pg_param_solde_delai: "Solde réglé avant départ",
    pg_months: "mois",
    pg_total_bookings: "Volume d'affaires (an 1)",
    pg_param_missing: "Renseignez le % d'acompte et le nombre de mois de réservation à l'avance dans la collecte pour un calcul fiable.",
    pg_admin_title: "Paramètres de calcul (Arcus)",
    pg_rate: "Taux de prime (%)",
    pg_bond_helper: "Aides au calcul du Bond level (Volume d'affaires × %)",
    pg_col_month: "Mois",
    pg_col_bookings: "Bookings departing",
    pg_col_cash_received: "Cash Received",
    pg_col_cash_held: "Cash Held",
    pg_col_exposure: "Exposure",
    pg_col_last_bond: "Bond N-1",
    pg_col_bond: "Bond level",
    pg_col_premium: "Premium",
    pg_year1_tag: "AN 1",
    pg_year2_tag: "AN 2 · projection",
    pg_total_year1: "TOTAL — Année 1",
    pg_annual_ht: "Prime annuelle HT",
    pg_peak_exposure: "Exposition max (an 1)",
    pg_annual_ttc: "Prime annuelle TTC",
    pg_formula_cash: "acompte × Bookings(mois+réserv) + solde × Bookings(mois+solde)",
    pg_formula_premium: "Bond level × taux ÷ 12 · TTC = HT × 1,09 (taxe 9 %)",
    pg_last_bond_hint: "Bond N-1 : vide en année 1 · renseigné automatiquement au renouvellement (exposition de l'année précédente).",
    // ── Lot 1 : cotation + sections Documents ──
    pg_cotation_title: "Cotation (projet d'assurance)",
    pg_cotation_empty: "Aucune période de cotation définie.",
    pg_generate_cotation: "Générer la cotation",
    pg_regenerate_cotation: "Regénérer la cotation",
    pg_cotation_generated: "Cotation générée le",
    pg_cotation_none: "Aucune cotation générée",
    pg_cotation_confirm_title: "Générer la cotation ?",
    pg_cotation_confirm_desc: "La cotation sera enregistrée et le projet d'assurance deviendra disponible dans l'onglet Documents.",
    pg_cotation_confirm_btn: "Générer",
    doc_section_projet: "Projet d'assurance",
    doc_section_contractuelles: "Pièces contractuelles",
    doc_projet_ready: "Cotation du",
    doc_projet_locked: "Générez la cotation dans l'onglet Payment Graph pour activer le projet d'assurance.",
    doc_projet_badge_todo: "À générer",
    // ── Lot 3 : déclarations + variations ──
    pg_col_declarations: "Declarations",
    pg_period_declared: "Période déclarée",
    pg_period_vs: "vs prév.",
    pg_over_forecast: "CA en hausse",
    pg_create_variation: "Créer une variation",
    pg_variation_created: "Variation créée",
    pg_variations_title: "Variations de prime",
    pg_variation_label: "Variation",
    pg_variation_badge_draft: "Brouillon",
    pg_variation_badge_done: "Généré",
    pg_variation_generate: "Générer l'appel de prime de variation",
    pg_variation_regenerate: "Regénérer l'appel de prime",
    pg_variation_generated: "Appel de prime généré le",
    pg_variation_confirm_title: "Générer l'appel de prime de variation ?",
    pg_variation_confirm_desc: "L'appel de prime de variation sera enregistré et apparaîtra dans l'onglet Documents, sous les pièces contractuelles.",
    pg_variation_confirm_btn: "Générer",
    doc_section_variations: "Appels de prime de variation",
    doc_variation_label: "Appel de prime de variation",
    // ── Workflow étude/police GF ──
    etude_title: "Étude du dossier",
    etude_locked_note: "Section verrouillée — la police est souscrite.",
    numero_projet: "Numéro de projet",
    date_effet_prev: "Date d'effet prévisionnelle",
    date_prev_locked_devis: "Verrouillée au passage en devis.",
    step_hint_demande_pieces: "Le client complète son dossier et le transmet à Arcus.",
    step_hint_en_cours: "Atteint automatiquement quand le client transmet son dossier.",
    step_hint_devis: "Atteint quand le projet d'assurance est généré.",
    repasser_btn: "Repasser en Demande de pièces et informations",
    repasser_confirm_title: "Repasser le dossier en Demande de pièces ?",
    repasser_confirm_desc: "Le formulaire redevient modifiable par le client ; les informations déjà saisies sont conservées. Le dossier repart au statut « Demande de pièces et informations ».",
    repasser_confirm_btn: "Repasser en Demande de pièces",
    police_locked_note: "Section activée à la souscription de la police.",
    // ── Souscription GF ──
    souscrire_btn: "Souscrire la police",
    souscrire_need_date: "Renseignez la date d'effet.",
    souscrire_confirm_title: "Souscrire la police",
    souscrire_confirm_desc: "Confirmez les informations ci-dessous pour créer la police. La section « La Police » sera activée et l'étude du dossier verrouillée.",
    souscrire_date_label: "Date d'effet de la police",
    souscrire_npolice_label: "Numéro de police",
    souscrire_freq_label: "Fréquence du monitoring",
    souscrire_freq_hint: "Ce choix verrouille la fréquence dans l'onglet Risk Monitoring.",
    souscrire_confirm_btn: "Souscrire",
    // ── Tableau parallèle déclarations ──
    pg_group_original: "Payment Graph (prévisionnel)",
    pg_group_declarations: "Suivi des déclarations",
    pg_col_updated_exposure: "Updated exposure",
    pg_col_updated_bond: "Updated bond level",
    // ── Lot 1 : bond level par périodes ──
    pg_define_bond: "Définir bond level",
    pg_bond_modal_title: "Définir le bond level d'une période",
    pg_bond_modal_desc: "La période démarre au 1er mois non couvert. Choisissez le mois de fin et le montant : tous les mois de la période prendront ce bond level.",
    pg_bond_modal_confirm: "Définir la période",
    pg_bond_period_start: "Début (auto)",
    pg_bond_period_end: "Fin de période",
    pg_bond_amount: "Montant du bond level",
    pg_bond_expo_max: "Utiliser l'Exposure Max :",
    pg_bond_periods_recap: "Périodes bond level",
    pg_bond_periods_none: "Aucune période définie — cliquez « Définir bond level » sur le 1er mois.",
    pg_bond_periods_incomplete: "12 mois non encore couverts",
    pg_bond_remove_last: "Retirer la dernière",
    pg_bond_reset: "Réinitialiser",
    // ── Lot 2 : cotation auto ──
    pg_cotation_auto_hint: "La cotation est générée automatiquement à partir des périodes bond level (dates + exposition + taux).",
    pg_cotation_need_bond: "Définissez d'abord les périodes de bond level dans le tableau ci-dessus.",
    pg_cotation_incomplete: "Couvrez les 12 mois avec des périodes bond level et renseignez le taux pour générer la cotation.",
    // ── Lot 3 : déclarations mois futurs ──
    surveillance_anticipation_hint: "Anticipation possible — modifiable jusqu'à sa déclaration, puis verrouillé.",
    // ── Lot 4 : section variations ──
    pg_variations_hint: "Les variations sont calculées automatiquement à partir des déclarations validées en hausse, découpées par période de bond level.",
    pg_var_peakbond_title: "Peak bond % par période",
    pg_var_period: "Période",
    pg_var_peakbond: "Peak bond %",
    pg_var_booking_initial: "Booking Departing initial",
    pg_var_booking_new: "Nouveau Booking Departing",
    pg_var_increase: "Hausse",
    pg_var_none: "Aucune variation — aucune déclaration validée en hausse pour le moment.",
    pg_var_value: "Valeur variation",
    pg_var_days: "Jours",
    pg_variation_see_section: "→ voir la section Variations",
    pg_chart_title: "Bond graph — courbes",
    surveillance_declare_confirm_title: "Déclarer à Arcus Solutions ?",
    surveillance_declare_confirm_desc: "Les volumes ci-dessous seront transmis à Arcus Solutions pour validation. Après confirmation, cette période sera définitivement verrouillée et ne pourra plus être modifiée.",
    surveillance_declare_confirm_btn: "Confirmer la déclaration",
    pg_var_appel_title: "Appel de prime de variation",
    pg_var_appel_pending_desc: "Les variations en attente ci-dessous seront regroupées dans un seul appel de prime.",
    pg_var_appel_none: "Aucune variation en attente d'appel de prime.",
    pg_var_appel_generate: "Générer l'appel de prime de variation",
    pg_var_appel_history: "Appels générés",
    pg_var_appel_confirm_title: "Générer l'appel de prime de variation ?",
    pg_var_appel_confirm_desc: "Sélectionnez les variations à inclure dans cet appel de prime. Les variations non cochées resteront en attente pour un prochain appel.",
    pg_var_appel_confirm_btn: "Générer l'appel de prime",
    pg_var_badge_covered: "Incluse dans l'appel du",
    pg_var_badge_pending: "En attente d'appel",
    pg_table_title: "Payment graph",
    surveillance_declare_validate_btn: "Déclarer et valider",
    surveillance_declare_validate_desc: "Vous déclarez ces volumes au nom du client : la période sera immédiatement déclarée ET validée, puis définitivement verrouillée. Le Payment Graph sera mis à jour.",
    pf_title: "Portefeuille Garantie Financière",
    pf_contracts: "dossiers",
    pf_col_month: "Mois de création",
    pf_col_status: "Statut",
    pf_col_name: "Dossier",
    pf_col_country: "Pays",
    pf_col_broker: "Courtier",
    pf_col_prev_date: "Date prévisionnelle",
    pf_direct: "Direct",
    pf_search: "Client / N° de police…",
    pf_filter: "Filtrer",
    pf_filter_search: "Rechercher…",
    pf_filter_all: "Tout sélectionner",
    pf_filter_none: "Tout désélectionner",
    pf_filter_clear_all: "Effacer tous les filtres",
    pf_no_rows: "Aucun dossier ne correspond aux filtres.",
    pg_mgmt_fees: "Frais de gestion",
  },



  account: {
    title: "Mon compte",
    breadcrumb: "ESPACE PERSONNEL",
    profile: "Mon profil",
    change_password: "Changer mon mot de passe",
    current_password: "Mot de passe actuel",
    update_password_btn: "Mettre à jour le mot de passe",
    password_changed: "Mot de passe modifié avec succès.",
    field_nom: "Nom complet",
    field_email: "Email",
    field_role: "Statut",
  },
  utilisateurs: { col_last_login: "Dernière connexion", never_connected: "Jamais connecté",
    create_mode_label: "Méthode de création du compte",
    mode_link: "Envoyer un lien d'activation",
    mode_password: "Définir un mot de passe",
    password_label: "Mot de passe",
    password_ph: "Au moins 8 caractères",
    password_info: "Le compte sera immédiatement utilisable avec ce mot de passe. Aucun email ne sera envoyé.",
    pwd_too_short: "Le mot de passe doit contenir au moins 8 caractères.",
    title: "Comptes utilisateur",
    count: "compte",
    count_plural: "comptes",
    create_btn: "+ Créer un utilisateur",
    search_placeholder: "Rechercher par nom ou email…",
    filter_all: "Tous",
    statut_actif: "Actif",
    statut_inactif: "Inactif",
    breadcrumb: "COMPTES UTILISATEUR",
    new_title: "Nouveau compte",
    edit_title: "Modifier le compte",
    field_nom: "Nom complet",
    field_email: "Email",
    field_role: "Statut (rôle)",
    field_client: "Client rattaché",
    field_courtier: "Courtier de rattachement",
    field_statut: "État du compte",
    create_info: "Un email d'activation sera envoyé à l'adresse renseignée. L'utilisateur définira son mot de passe via le lien reçu.",
    create_and_send: "Créer et envoyer le lien",
    send_reset: "Envoyer un lien de réinitialisation",
    reset_password: "Réinitialiser le mot de passe",
    reset_sent_simple: "Lien de réinitialisation envoyé",
    saved: "Modifications enregistrées",
    created: "Compte créé — email envoyé",
    delete_confirm: "Supprimer définitivement le compte de",
  },
  docs_souscription: {
    title: 'Documents de souscription',
    subtitle: 'Pièces à collecter avant souscription',
    doc_projet_signe: "Projet d'assurance signé",
    doc_certificat: "Certificat d'immatriculation",
    doc_rib: 'RIB bancaire',
    doc_releve_sinistre: 'Relevé sinistre',
    rib_condition: 'Requis — fractionnement non annuel',
    releve_condition: 'Requis — risque déjà assuré',
    add_doc: '+ Ajouter un document requis',
    add_doc_placeholder: "Ex. Attestation précédent assureur",
    add_doc_label: 'Intitulé du document',
    upload_btn: 'Déposer',
    replace_btn: 'Remplacer',
    preview_btn: 'Visualiser',
    accept_btn: 'Accepter',
    refuse_btn: 'Refuser',
    status_attente: 'En attente',
    status_uploade: 'Déposé',
    status_accepte: 'Accepté',
    status_refuse: 'Refusé',
    refuse_category: 'Catégorie de refus *',
    refuse_category_placeholder: '— Sélectionner une catégorie —',
    refuse_detail: 'Précision (optionnelle)',
    refuse_email_btn: '📧 Envoyer un email de refus au client',
    refuse_email_title: 'Email — Documents refusés',
    refuse_email_copy: 'Copier',
    refuse_email_open: 'Ouvrir dans la messagerie',
    refuse_email_copied: 'Copié !',
    refuse_email_subject: 'Votre dossier — Documents à régulariser',
    refuse_no_refused: 'Aucun document refusé à ce jour.',
    refuse_title: 'Justification du refus',
    refuse_label: 'Motif du refus *',
    refuse_placeholder: "Ex. : Document illisible, mauvais document…",
    refuse_email_note: 'Ce commentaire sera envoyé par email au client.',
    refuse_confirm: 'Confirmer le refus',
    locked_msg: 'Accepté',
    rejected_comment: 'Motif :',
    completion: 'accepté(s)',
    accept_confirm: 'Accepter ce document ?',
    file_size: 'Max 20 Mo — PDF, images, Word',
    unlock_btn: 'Déverrouiller',
    unlock_confirm: 'Remettre ce document en attente de validation ?',
    doc_gf_cert_immat: "Certificat d'immatriculation",
    doc_gf_statuts: "Statuts de l'entreprise",
    doc_gf_cv_dirigeant: 'CV du dirigeant',
    doc_gf_piece_id: "Pièce d'identité du dirigeant",
    doc_gf_presentation_projet: 'Présentation du projet',
    doc_gf_previsionnel: "Prévisionnel d'activité détaillé",
    doc_gf_cgv: 'Conditions générales de vente',
    doc_gf_presentation_activites: 'Présentation des activités',
    doc_gf_previsionnel_annuel: "Prévisionnel d'activité pour l'année à garantir",
    doc_gf_bilan_cr: 'Dernier bilan et compte de résultat détaillé',
    doc_gf_attestation_rcpro: 'Attestation RC Professionnelle en cours',
    doc_gf_attestation_fonds: 'Attestation de pointe fonds détenus',
    readonly_banner: 'Vue en lecture seule — dépôt et visualisation uniquement',
    broker_readonly: 'En tant que courtier, vous pouvez uniquement consulter les fiches clients.',
    address_siege: 'Adresse du siège social',
    broker_status_locked: 'Prospect — statut défini par le souscripteur Arcus',
    accepted_label: 'accepté(s)',
    required_label: 'Requis',
    delete_btn: '🗑 Supprimer',
    doc_contrat_reservation: "Copie du contrat de réservation avec l'agence",
    doc_preuve_paiement: 'Preuve de paiement(s)',
    doc_bon_voucher: 'Bon / Voucher non utilisé (le cas échéant)',
    delete_confirm: 'Supprimer ce document ?',
    // ── Verrou pack + ZIP (Lot C) ──
    lock_pack: "Verrouiller les pièces",
    unlock_pack: "Déverrouiller les pièces",
    generate_zip: "Générer le ZIP du pack",
    lock_confirm: "Verrouiller le pack de pièces ? Plus aucune modification ne sera possible tant qu'il n'est pas déverrouillé.",
    unlock_pack_confirm: "Déverrouiller le pack de pièces pour autoriser des modifications ?",
    zip_confirm: "Générer le ZIP du pack de pièces ?",
    zip_coming: "Génération du ZIP à venir.",
    pack_locked_note: "Pièces verrouillées.",
    pack_ready_note: "Toutes les pièces requises sont validées.",
  },
  chat: {
    open: "Ouvrir le chat",
    minimize: "Réduire",
    with_arcus: "Discussion avec Arcus",
    no_conv: "Aucune conversation",
    select_conv: "Sélectionnez une conversation",
    no_conv_yet: "Aucune conversation pour le moment",
    no_messages_yet: "Aucun message",
    send_first_message: "Envoyez votre premier message ci-dessous",
    message_placeholder: "Écrire un message…",
    participants: "membres",
    you: "Vous",
    add: "Ajouter",
    add_admin: "Ajouter un membre Arcus",
    remove_participant: "Retirer ce membre",
    confirm_remove_participant: "Retirer ce membre de la conversation ?",
    all_admins_already: "Tous les admins sont déjà membres",
    loading_error: "Conversation indisponible",
    back_list: "Retour aux conversations",
  },
  it_delete: {
    title: "God Mode — Suppression forcée",
    god_mode: "GOD MODE — IT",
    entity_client: "Client",
    entity_police: "Police",
    entity_intermediaire: "Intermédiaire",
    about_to_delete: "Vous êtes sur le point de supprimer définitivement",
    also_deleted: "ÉLÉMENTS LIÉS SUPPRIMÉS EN CASCADE",
    no_cascade: "Aucun élément lié à supprimer.",
    polices: "Polices",
    amendements: "Avenants",
    renouvellements: "Renouvellements (liens nettoyés)",
    clients_unlinked: "Clients liés (passeront en direct)",
    irreversible: "Cette action est irréversible.",
    confirm_btn: "Supprimer définitivement",
    impact_error: "Impossible de calculer l'impact.",
    delete_error: "Erreur lors de la suppression.",
    dossiers_linked: "Dossiers liés (paiements affectés)",
  },

  prestataires_section: {
    title: "Prestataires & Tour-opérateurs",
    breadcrumb: "PRESTATAIRES",
    count: "prestataire",
    count_plural: "prestataires",
    contacts_count: "contact",
    contacts_count_plural: "contacts",
    create_btn: "+ Nouveau prestataire",
    new_title: "Nouveau prestataire",
    search_placeholder: "Rechercher par nom, ville, numéro d'entreprise…",
    iban_set: "IBAN renseigné",
    tab_infos: "Le prestataire",
    tab_contacts: "Les contacts",
    tab_bank: "Informations bancaires",
    field_nom: "Nom du prestataire",
    field_adresse_1: "Adresse 1",
    field_adresse_2: "Adresse 2",
    field_code_postal: "Code postal",
    field_ville: "Ville",
    field_numero_entreprise: "Numéro d'entreprise",
    field_notes: "Notes internes",
    field_numero_compte: "Numéro de compte",
    field_iban: "IBAN",
    field_swift: "Code SWIFT / BIC",
    adresse_placeholder: "Numéro et rue",
    numero_placeholder: "SIREN, N° TVA, ID fiscal…",
    notes_placeholder: "Informations utiles : type d'activité, conditions de paiement…",
    bank_warning: "Ces informations seront utilisées automatiquement lors des paiements de sinistres en maintien de voyage.",
    err_nom: "Le nom du prestataire est obligatoire.",
  },

  phase_b: {
    count: "dossier",
    count_plural: "dossiers",
    empty: "Aucun dossier dans cette catégorie.",
    col_numero: "N° Dossier / Procédure",
    col_agence: "Agence",
    col_beneficiaire: "Bénéficiaire",
    col_montant: "Montant",
    col_date_action: "Date",
    col_par: "Par",
    confirm_title: "Confirmer l'action ?",
    refus_banner_title: "Dossier refusé par le Manager — motif :",
    send_validation_title: "Envoyer au Manager pour validation",
    send_validation_desc: "Une fois envoyé, le dossier passera en attente de validation Manager avant paiement.",
    send_validation_btn: "Envoyer pour validation",
    manager_validation_title: "Validation Manager requise",
    manager_validation_desc: "Ce dossier est prêt pour validation finale avant transmission à Accounts.",
    validate_btn: "Valider",
    refuse_btn: "Refuser",
    refuse_modal_title: "Motif de refus",
    refuse_modal_desc: "Le dossier retournera en statut « En cours ». Le motif sera visible par l'Admin.",
    refuse_motif_placeholder: "Précisez le motif du refus…",
    refuse_confirm_btn: "Confirmer le refus",
    ready_to_pay_title: "Prêt pour paiement",
    ready_to_pay_desc: "Le Manager a validé ce dossier. Accounts peut maintenant marquer le paiement comme effectué.",
    mark_paid_btn: "Marquer payé",
    mark_paid_confirm_title: "Confirmer le paiement effectué ?",
    mark_paid_confirm_desc: "Une fois confirmé, le dossier passera en statut « Paiement réalisé » et sera verrouillé.",
    mark_paid_confirm_btn: "Confirmer le paiement",
  },
  pending_validation: {
    title: "En attente validation Manager",
    subtitle: "Dossiers envoyés par les Admins, en attente de validation finale par un Manager.",
  },
  pending_payment: {
    title: "En attente paiement",
    subtitle: "Dossiers validés par le Manager, en attente de paiement par Accounts.",
    action_mark_paid: "Marquer payé",
    confirm_mark_paid: "Marquer ce dossier comme payé :",
    download_btn: "Générer le fichier des paiements en attente",
  },
  pending_balances: { col_received: "Reçu", col_remaining: "Restant dû",
    title: "Soldes en attente",
    subtitle: "Soldes restant à percevoir des voyageurs",
    download_btn: "Générer le fichier Excel",
    downloading: "Génération…",
    empty: "Aucun appel de fonds généré pour le moment.",
    paid: "Payé",
    unpaid: "En attente",
    col_file: "N° dossier",
    col_agency: "Agence",
    col_beneficiary: "Bénéficiaire",
    col_generated: "Appel généré le",
    col_deadline: "Date limite",
    col_balance: "Solde dû",
    col_paid: "Statut",
  },
  closed_dossiers: {
    title: "Dossiers clos",
    subtitle: "Dossiers payés et clôturés.",
    download_btn: "Télécharger un état du sinistre",
  },

  phase_c: {
    section_title: "Prestataires à payer (maintien du voyage)",
    section_subtitle: "Sélectionnez un ou plusieurs prestataires à payer pour permettre au client de maintenir son voyage.",
    add_prestataire: "Ajouter un prestataire",
    prestataire_num: "Prestataire ",
    select_prestataire: "Prestataire",
    select_placeholder: "Choisir un prestataire",
    amount: "Montant",
    reference: "Référence paiement",
    reference_placeholder: "Ex. Facture n°…",
    description: "Description",
    description_placeholder: "Ex. Hôtel 2 nuits, Vol retour Paris…",
    bank_locked: "Coordonnées bancaires (verrouillées — issues de la fiche centrale)",
    location: "Localisation",
    total: "Total des paiements prestataires",
    empty: "Aucun prestataire ajouté. Cliquez sur « Ajouter un prestataire » pour commencer.",
  },

  voyageur_intro: {
    title: "Bienvenue dans votre espace de demande de prise en charge",
    body: "Complétez les informations relatives à votre dossier de voyage, et transmettez les pièces nécessaires au traitement de votre dossier de prise en charge.",
    submit_title: "Votre dossier est complet ?",
    submit_desc: "Une fois soumis, votre dossier sera transmis à nos équipes pour traitement.",
    submit_btn: "Soumettre mon dossier",
    submit_confirm_title: "Soumettre votre dossier ?",
    submit_confirm_desc: "Vérifiez que toutes vos informations et pièces justificatives sont correctes. Après soumission, votre dossier passera en cours de traitement.",
    submit_confirm_btn: "Confirmer la soumission",
    status_section: "Statut de votre dossier",
    status_msg_attente: "Nous attendons que vous complétiez vos informations et transmettiez vos pièces justificatives, puis soumettiez votre dossier.",
    status_msg_traitement: "Votre dossier est en cours de traitement par nos équipes. Vous serez informé de son évolution.",
    status_msg_validation: "Votre dossier est en attente de validation finale par notre équipe.",
    status_msg_paiement: "Votre dossier a été validé. Le paiement est en cours de traitement.",
    status_msg_solde_paye: "Le solde a bien été reçu. Le traitement de votre dossier se poursuit.",
    status_msg_realise: "Le paiement a été réalisé. Votre dossier est clôturé.",
    status_msg_decline: "Votre dossier n'a malheureusement pas pu être retenu. Contactez-nous pour plus d'informations.",
  },

  phase_d4: {
    lock: "Verrouiller",
    unlock: "Déverrouiller",
    locked: "Verrouillé",
    lock_paiements: "Verrouiller les paiements",
    unlock_paiements: "Déverrouiller les paiements",
    date_naissance: "Date de naissance du bénéficiaire",
    sanction_title: "Recherche de sanction",
    sanction_btn: "Recherche de sanction réalisée",
    sanction_done: "Recherche de sanction effectuée — les paiements sont verrouillés.",
    sanction_undo: "Lever le verrou (Manager)",
    validation_checklist: "Conditions pour demander la validation",
    cond_paiements_locked: "Paiements verrouillés",
    cond_docs_approved: "Toutes les pièces justificatives approuvées",
    cond_sanction: "Recherche de sanction réalisée",
    cond_facture: "Facture(s) prestataire(s) uploadée(s)",
    cond_appel_fonds_paye: "Appel de fonds noté comme payé",
    request_validation_title: "Demander la validation du dossier",
    request_validation_desc: "Toutes les conditions sont réunies. Le dossier sera verrouillé et transmis au Manager.",
    request_validation_btn: "Demander la validation",
    validation_locked_hint: "Le bouton de demande de validation apparaîtra une fois toutes les conditions ci-dessus remplies.",
    decline_btn: "Décliner le dossier",
    decline_modal_title: "Décliner ce dossier ?",
    decline_modal_desc: "Le dossier passera en statut « Dossier décliné » et sera clos. Cette action peut être justifiée par un motif.",
    decline_motif_placeholder: "Motif du refus (optionnel)…",
    decline_confirm_btn: "Confirmer le refus",
  },
  phase_d4_facture: {
    title: "Facture du prestataire",
    upload: "Uploader la facture",
    replace: "Remplacer",
   view: "Visualiser", save_row_first: "Enregistrez d'abord ce prestataire pour pouvoir joindre sa facture.",},
  phase_d5: {
    marquer_paye: "Marquer payé",
    annuler_paye: "Annuler le paiement",
    paye_badge: "Payé",
  },
  phase_solde: { af_confirm_btn: "Confirmer l'envoi de l'appel de fonds", af_confirm_title: "Confirmer l'envoi de l'appel de fonds ?", af_confirm_desc: "Cette action fait passer le dossier en « Attente paiement du solde », affiche définitivement la section Gestion du solde et verrouille la génération d'un nouvel appel de fonds. Action irréversible.", af_confirmed_badge: "Appel de fonds confirmé",
    admin_valid_title: "Validation du dossier administratif",
    admin_valid_desc: "Confirmez que les informations et les pièces justificatives sont conformes (validation sur la forme).",
    admin_valid_done: "Dossier administratif validé. Vous pouvez générer l'appel de fonds.",
    admin_valid_btn: "Valider le dossier administratif",
    admin_valid_cancel: "Annuler la validation",
    admin_valid_need_docs: "Toutes les pièces justificatives doivent être acceptées avant de valider.",
    gen_blocked: "Validez le dossier administratif pour générer l'appel de fonds",
    section_title: "Gestion du paiement du solde",
    balance_due: "Solde dû",
    deadline: "Date limite de paiement",
    received_title: "Paiements reçus",
    received_empty: "Aucun paiement reçu enregistré.",
    add_received: "Ajouter un paiement reçu",
    col_date: "Date de réception",
    col_emetteur: "Émetteur du paiement",
    col_emetteur_ph: "Nom de l'émetteur",
    col_montant: "Montant payé",
    total_received: "Total des fonds reçus",
    remaining: "Restant à recevoir",
    mark_paid_btn: "Marquer payé",
    unlock_btn: "Déverrouiller",
    confirm_recu_btn: "Confirmer réception du solde",
    recu_confirmed: "Réception du solde confirmée",
    recu_cancel: "Annuler la confirmation",
    save_confirm_title: "Enregistrer les paiements reçus ?",
    save_confirm_desc: "Les champs des paiements saisis seront verrouillés. Vous pourrez les déverrouiller ensuite si besoin.",
    save_confirm_btn: "Enregistrer et verrouiller",
    recu_confirm_title: "Confirmer la réception du solde ?",
    recu_confirm_desc: "Le solde est entièrement reçu. Cette action marque le dossier comme payé.",
    recu_confirm_btn: "Confirmer la réception",
    cond_prestataire_facture: "Au moins un prestataire enregistré avec sa facture",
    validation_lock_banner: "Dossier envoyé pour validation. Il est verrouillé tant que le Manager n'a pas statué.",
    send_validation_title: "Envoi pour validation",
    send_validation_desc: "Envoyer le dossier au Manager pour validation des paiements prestataires.",
    send_validation_btn: "Envoi pour validation",
    send_validation_confirm_title: "Envoyer le dossier pour validation ?",
    send_validation_confirm_desc: "Le dossier sera transmis au Manager et entièrement verrouillé jusqu'à sa décision.",
    send_validation_confirm_btn: "Envoyer pour validation",
  },
  phase_d4b: {
    entreprise_nom: "Nom de l'entreprise",
    resp_nom: "Nom du responsable légal",
    resp_prenom: "Prénom du responsable légal",
    date_naissance: "Date de naissance",
    nationalite: "Nationalité",
    sanction_label: "Recherche de sanction réalisée",
    sanction_confirmed: "Recherche de sanction confirmée",
  },

  gestiondoc: {
    title: "Gestion documentaire",
    subtitle: "Modèles de documents — uploadez une nouvelle version quand un modèle change.",
    add_template: "Ajouter un modèle",
    cat_gf: "Garantie Financière",
    cat_rc_pro: "RC Professionnelle",
    cat_commun: "Commun",
    cat_sinistre: "Sinistres",
    no_file: "Aucun fichier",
    download: "Télécharger",
    upload_new: "Nouvelle version",
    history: "Historique",
    systeme_tag: "Catalogue",
    custom_tag: "Personnalisé",
    inactive: "Inactif",
    active: "Actif",
    delete_confirm: "Supprimer ce modèle personnalisé ?",
    empty: "Aucun modèle.",
    hist_title: "Historique des versions",
    current_tag: "Courante",
    modal_upload_title: "Uploader une nouvelle version",
    modal_file: "Fichier .docx ou .pdf",
    modal_notes: "Note de version (facultatif)",
    modal_upload_btn: "Uploader",
    drop_hint: "Glissez un fichier ici ou cliquez pour parcourir",
    add_title: "Nouveau modèle",
    add_nom: "Nom du modèle",
    add_categorie: "Catégorie",
    add_desc: "Description",
    add_btn: "Créer le modèle",
  },
};

export default fr;
